module.exports = require("update-notifier");;